import { render, staticRenderFns } from "./TransferLeaveStudent.vue?vue&type=template&id=182214fb&scoped=true"
import script from "./TransferLeaveStudent.vue?vue&type=script&lang=js"
export * from "./TransferLeaveStudent.vue?vue&type=script&lang=js"
import style0 from "./TransferLeaveStudent.vue?vue&type=style&index=0&id=182214fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182214fb",
  null
  
)

export default component.exports